// About module constants
const ManufactureDate = '2026-08-13';
const ManufacturerSymbol = 'Manufacturer_Symbol';
const ManufacturerName = 'Eyetelligence Pty Ltd';
const ManufacturerParentName = 'Optain Health';
const ManufacturerAddress = 'Level 8, 1341 Dandenong Road, Chadstone VIC 3148';
const ProductVersion = '1.1.0';
const UserManualSymbol = 'User_Manual_Symbol';

export const About = {
  ManufactureDate,
  ManufacturerSymbol,
  ManufacturerName,
  ManufacturerParentName,
  ManufacturerAddress,
  ProductVersion,
  UserManualSymbol,
};
